/* eslint-disable max-lines-per-function */
import { useTranslation } from 'react-i18next';
import {
  InputFormField,
  TimeInputFormField,
} from '@/domain/termine/features/CreateTermin/Sheet/components';
import { useCreateTermineFormContext } from '@/domain/termine/features/CreateTermin/shared/useCreateTermineFormContext';
import { TextAreaFormField } from '@/domain/termine/features/CreateTermin/Sheet/components/FormFields/TextAreaFormField';
import { useState } from 'react';
import { Button } from '@/components/ui/button';
import { ColorPickerDrawer } from '@/domain/termine/features/CreateTermin/Drawer/components/ColorPickerDrawer';
import { FormMessage } from '@/components/ui/form';
import { RepetitionIntervalFormField } from '@/domain/termine/features/CreateTermin/shared/RepetitionIntervalFormField';
import { ColorPickerFormField } from '@/domain/termine/features/CreateTermin/shared/FormFields/ColorPickerFormField';
import { DatePickerDrawer } from '@/domain/termine/features/CreateTermin/Drawer/components/DatePickerDrawer';
import { DatePickerSheet } from '@/domain/termine/features/CreateTermin/Sheet/components/ DatePickerSheet';
import { DatePickerFormField } from '@/domain/termine/features/CreateTermin/shared/FormFields/DatePickerFormField';
import ColorPicker from '@/domain/termine/components/ColorPicker/ColorPicker';
import { CalendarSelectDrawer } from '@/domain/termine/features/CreateTermin/Drawer/components/CalendarSelectDrawer';
import { CalendarSelectFormField } from '@/domain/termine/features/CreateTermin/shared/FormFields/CalendarSelectFormField';
import { useCalendarContext } from '@/domain/termine/features/Calendar/shared/CalendarContext';
import { CalendarSelectSheet } from '@/domain/termine/features/CreateTermin/Sheet/components/CalendarSelectSheet';
import { ImageFormField } from '@/domain/termine/features/CreateTermin/Sheet/components/FormFields/ImageFormField';

export function CreateTermineFormContent() {
  const { t } = useTranslation();
  const { form, isMobile } = useCreateTermineFormContext();
  const { kalender } = useCalendarContext();
  const [showSpecials, setShowSpecials] = useState(false);

  const timeErrors =
    form.formState.errors.ende?.message ??
    form.formState.errors.beginn?.message;

  return (
    <div className="flex flex-col gap-4 p-6 pb-24">
      <span className="font-normal text-neutrals-700 text-xs">
        {t('domain.termine.sheet.pflichtfelder')}
      </span>
      <div className="flex flex-col flex-1 gap-4">
        <ImageFormField />
        <div className="flex flex-col gap-4 flex-1">
          <div className="flex gap-4">
            <InputFormField />
            <ColorPickerFormField>
              {({ value, onChange }) =>
                isMobile ? (
                  <ColorPickerDrawer value={value} onChange={onChange} />
                ) : (
                  <ColorPicker value={value} onChange={onChange} />
                )
              }
            </ColorPickerFormField>
          </div>

          <div className="flex flex-col md:flex-row gap-4">
            <DatePickerFormField name="datum">
              {({ value, onChange, label }) =>
                isMobile ? (
                  <DatePickerDrawer
                    value={value}
                    onChange={onChange}
                    label={label}
                  />
                ) : (
                  <DatePickerSheet
                    value={value}
                    onChange={onChange}
                    label={label}
                  />
                )
              }
            </DatePickerFormField>
            <div className="flex flex-col">
              <div className="flex gap-4">
                <TimeInputFormField name="beginn" />
                <TimeInputFormField name="ende" />
              </div>
              {timeErrors && (
                <div>
                  <FormMessage>{timeErrors}</FormMessage>
                </div>
              )}
            </div>
          </div>
          <RepetitionIntervalFormField />
          <CalendarSelectFormField>
            {({ value, onChange }) =>
              isMobile ? (
                <CalendarSelectDrawer
                  kalender={kalender}
                  value={value}
                  onChange={onChange}
                />
              ) : (
                <CalendarSelectSheet
                  kalender={kalender}
                  value={value}
                  onChange={onChange}
                />
              )
            }
          </CalendarSelectFormField>
          <TextAreaFormField name="beschreibung" />
          {!showSpecials && (
            <Button
              type="button"
              variant="ghost-primary"
              className="self-start w-auto"
              onClick={() => setShowSpecials(true)}>
              <span className="text-sm">
                {t('domain.termine.addAdditionalInformation')}
              </span>
            </Button>
          )}
          {showSpecials && <TextAreaFormField name="specials" />}
        </div>
      </div>
    </div>
  );
}
